import { IApplicationState } from '../types/redux';
import { IPromoInfo } from '../types/newbuilding/promoInfo';

export const promoInfoSelector = (state: IApplicationState): IPromoInfo | null => {
  return state.promo.promo;
};
